import http from './http'

/**
 * 获取一些常用类型数据
 *
 * @param {*} params
 */
export function getTypeCommon(params) {
	return http.httpGet('/type/common', params)
}
